'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.trackerSuccess = exports.trackerError = exports.trackerStart = exports.trackerMultipleFinish = exports.trackerMultipleStart = undefined;

var _types = require('./types');

var trackerMultipleStart = exports.trackerMultipleStart = function trackerMultipleStart(params, trackerType, trackerIds) {
    return {
        type: _types.TRACKER_MULTIPLE_START,
        payload: {
            params: params,
            trackerType: trackerType,
            trackerIds: trackerIds
        }
    };
};

var trackerMultipleFinish = exports.trackerMultipleFinish = function trackerMultipleFinish(params, trackerType, trackerIds, responses) {
    return {
        type: _types.TRACKER_MULTIPLE_FINISH,
        payload: {
            params: params,
            trackerType: trackerType,
            trackerIds: trackerIds,
            responses: responses
        }
    };
};

var trackerStart = exports.trackerStart = function trackerStart(params, trackerType, trackerId) {
    return {
        type: _types.TRACKER_START,
        payload: {
            params: params,
            trackerType: trackerType,
            trackerId: trackerId
        }
    };
};

var trackerError = exports.trackerError = function trackerError(error, params, trackerType, trackerId) {
    return {
        type: _types.TRACKER_ERROR,
        error: true,
        payload: {
            error: error,
            params: params,
            trackerType: trackerType,
            trackerId: trackerId
        }
    };
};

var trackerSuccess = exports.trackerSuccess = function trackerSuccess(response, params, trackerType, trackerId) {
    return {
        type: _types.TRACKER_SUCCESS,
        payload: {
            response: response,
            params: params,
            trackerType: trackerType,
            trackerId: trackerId
        }
    };
};
//# sourceMappingURL=track.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/tracking/lib/cjs/redux/actions/track.js
 ** module id = 166
 ** module chunks = 0
 **/